import type { Components, Theme } from "@mui/material";

export const MuiDialogActions: Components<Theme>["MuiDialogActions"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(2, 3), // top, right, bottom, left
      borderTop: `1px solid ${theme.palette.divider}`,
    }),
  },
};
